<template>
  <div>
    <el-dialog
        title="更新角色"
        :visible.sync="updateDialog"
        width="800px">
      <div v-loading="updateLoading" style="padding-right: 16px">
        <el-form :model="role" :rules="Roles" ref="Roles" label-width="120px" class="demo-ruleForm">
          <el-row>
            <el-col :span="11">
              <el-form-item label="名称：" prop="name">
                <el-input style="width: 200px" v-model="role.name" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="分组：">
                <el-select style="width: 200px" :disabled="role.children" v-model="role.parentId" placeholder="请选择">
                  <el-option
                      v-for="item in tableList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="菜单列表：">
                <el-cascader v-model="role.menuIdList"
                    :options="allMenuTree"  collapse-tags
                    :props="{ multiple: true,value: 'id',label: 'title',children: 'children'}"
                    clearable></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="备注：">
                <el-input type="textarea" placeholder="请输入内容" v-model="role.remark">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialog = false">取 消</el-button>
        <el-button :disabled="updateLoading" type="danger" @click="updateRole">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {updateRole,getRoleDetail} from "../../../../api/contacts/role";
import {selectAllMenu} from "../../../../api/menu"
export default {
  name: "UpdateRole",
  data() {
    return {
      allMenuTree:[],
      updateDialog:false,
      updateLoading:false,
      role:{
        name:"",
        parentId: null,
        remark: "",
        menuIdList:[]
      },
      Roles: {
        name: [{
          required: true,
          message: '请输入名称！',
          trigger: 'blur'
        },],
      },
      tableList:[]
    }
  },
  methods:{
    openDialog(item,list) {
      this.tableList = list;
      this.updateDialog = true;
      this.getRoleDetail(item);
    },
    getRoleDetail(item){
      getRoleDetail(item).then(val=>{
        if (val.status == 200){
          this.role = val.data;
          this.role.menuIdList = this.convertToPaths(this.role.menuIdList,this.allMenuTree);
        }
      })
    },
    updateRole(){
      this.$refs.Roles.validate((valid)=>{
        if(valid){
          this.updateLoading = true;
          this.role.menuIdList = [...new Set(this.role.menuIdList.flat())];
          updateRole(this.role).then(val => {
            if (val.data > 0){
              this.$emit('refresh');
              this.updateDialog = false;
              this.updateLoading = false;
              this.$message({message: '更新成功', type: 'success'});
              Object.keys(this.role).forEach((key) => (this.role[key] = null));
            }else {
              this.$message.error('更新失败！');
            }
          })
        }
      })
    },
    convertToPaths(ids, treeData) {
      return ids.map(id => {
        const path = []
        function findPath(nodes, targetId) {
          for (const node of nodes) {
            path.push(node.id)
            if (node.id === targetId) return true
            if (node.children && findPath(node.children, targetId)) return true
            path.pop()
          }
          return false
        }
        findPath(treeData, id)
        return path
      })
    }
},
  created() {
    selectAllMenu().then(val=>{
      if (val.status == 200){
        this.allMenuTree = val.data;
      }
    })
  }
}
</script>

<style scoped>

</style>
<style>
.el-cascader__tags {
  display: inline-flex;
  margin-right: 45px;
  flex-wrap: nowrap;
}

</style>